<template>
  <header class="page-header">
    <i
      class="fas fa-arrow-left btn"
      v-if="isShowBackBtn"
      @click="backToPreviousPage"
    ></i>
    <i
      class="fas fa-bars btn"
      v-if="isShowHamburgerBtn"
      @click="showMobileNavBar"
    ></i>
    <h1 class="title">{{ title }}</h1>
    <div class="filter" v-if="isShowFilterBtn" @click="showMobileFilter">
      <p>ตัวกรอง</p>
      <div class="badge" v-if="showFilterResult">{{ showFilterResult }}</div>
      <i class="fas fa-search btn"></i>
    </div>
    <slot></slot>
  </header>
</template>

<script>
import SearchForm from "../components/SearchForm";
import { mSize } from "../StaticVariable";

export default {
  props: [
    "title",
    "isJobListPage",
    "isInvoiceListPage",
    "showFilterResult"
  ],
  components: {
    SearchForm
  },
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < mSize;
    },
    isShowBackBtn() {
      return !this.isJobListPage
        && !this.isInvoiceListPage
        && this.isMobile;
    },
    isShowHamburgerBtn() {
      return (this.isJobListPage || this.isInvoiceListPage)
        && this.isMobile;
    },
    isShowFilterBtn() {
      return this.isJobListPage && this.isMobile;
    }
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    backToPreviousPage() {
      this.$router.back();
    },
    showMobileNavBar() {
      this.$emit("showMobileNavBar");
    },
    showMobileFilter() {
      this.$emit("showMobileFilter");
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.page-header {
  display: flex;
  align-items: center;
  padding-block: 16px;
  padding-inline: 32px;
  background-color: $supplier-primary-color;
  border-bottom: 1px solid $color-light-gray-1;

  > .title {
    font-size: $font-20;
    font-weight: bold;
    line-height: 1.6;
    flex-grow: 1;
    margin-bottom: 0;
    color: $white;
  }

  > .filter {
    display: flex;
    flex-direction: row;
    color: white;
    align-items: center;
    border: solid 1px $white;
    margin-right: 24px;
    border-radius: 32px;
    padding: 2px 16px;

    > p {
      color: $white;
      font-size: $font-16;
    }

    > .badge {
      font-size: $font-14;
      font-weight: bold;
      background-color: $white;
      color: $supplier-primary-color;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 4px;
    }

    > .btn {
      padding: 0;
      font-size: $font-16;
      border: 0;
      color: $white;
      padding-left: 12px;
    }
  }

  > .filter:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > .btn {
    padding: 24px;
    font-size: $font-16;
    border: 0;
    color: $white;
  }

  > .btn:hover {
    cursor: pointer;
    opacity: 0.7;
  }
}

@media (max-width: ($m-size - 1)) {
  .page-header {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/other-web/supplier/components/SupplierPageHeader.vue